// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.theme-message,\r\n.theme-picker-dropdown {\r\n  z-index: 99999 !important;\n}\n.theme-picker .el-color-picker__trigger {\r\n  height: 18px !important;\r\n  width: 18px !important;\r\n  padding: 0;\n}\n.theme-picker .el-color-picker__trigger ..el-color-picker__color {\r\n  border: none;\n}\n.theme-picker-dropdown .el-color-dropdown__link-btn {\r\n  display: none;\n}\r\n", ""]);
// Exports
module.exports = exports;
